// extracted by mini-css-extract-plugin
module.exports = {"productImages":"st","mobileCarousel":"tt","desktopCarousel":"ut"};